import axios from "axios";
const api = process.env.VUE_APP_API_URL;

export default {
  state: {
    token: localStorage.getItem("token") || "",
    authError: ""
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authError: state => state.authError
  },
  mutations: {
    authSuccess: (state, token) => {
      state.token = token;
      state.authError = "";
      localStorage.setItem("token", token);
      axios.defaults.headers.common["X-token"] = token;
    },
    authFailed: (state, error) => {
      state.authError = error;
    },
    authLogout: state => {
      state.token = "";
      localStorage.removeItem("token");
      axios.defaults.headers.common["X-token"] = "";
    }
  },
  actions: {
    authRequest: ({ commit }, user) => {
      return new Promise((resolve, reject) => {
        axios
          .post(api + "user/login", user)
          .then(resp => {
            commit("authSuccess", resp.data.token);
            resolve(resp);
          })
          .catch(err => {
            commit("authFailed", err.response.data);
            commit("authLogout");
            reject(err);
          });
      });
    }
  }
};
